import type { Fatia } from "../types";

/** Cores do Google (tons de texto sobre fundo pastel) e as tintas correspondentes. */
export const GOOGLE = {
  azul: "#1264C7",
  vermelho: "#D93025",
  amarelo: "#E37400",
  verde: "#188038",
  azulTinta: "#EAF1FB",
  vermelhoTinta: "#FCE8E6",
  amareloTinta: "#FFF7E0",
  verdeTinta: "#EAF7EE",
  cinza: "#80868B",
  cinzaTinta: "#F1F3F4",
};

/** Sequência fixa para fatias de status: nunca reordenada pela contagem. */
export const CORES_DE_STATUS: Record<string, string> = {
  ACTIVE: GOOGLE.verde,
  PENDING_SYNC_LEGACY_KEYWORDS: GOOGLE.amarelo,
  WAITING_FIRST_PAYMENT: GOOGLE.azul,
  WAITING_INITIAL_SYNC: "#7B1FA2",
  LOGIN_PENDING: "#5F6368",
  PENDING_INITIAL_PROFILE_UPDATE: "#00897B",
  INACTIVE: "#9AA0A6",
  CANCELED: GOOGLE.vermelho,
};

export const ROTULO_DE_STATUS: Record<string, string> = {
  ACTIVE: "Ativos",
  PENDING_SYNC_LEGACY_KEYWORDS: "Aguardando sincronizar palavras",
  WAITING_FIRST_PAYMENT: "Aguardando 1º pagamento",
  WAITING_INITIAL_SYNC: "Aguardando 1ª sincronização",
  LOGIN_PENDING: "Aguardando login",
  PENDING_INITIAL_PROFILE_UPDATE: "Aguardando atualização inicial",
  INACTIVE: "Inativos",
  CANCELED: "Cancelados",
};

export const ROTULO_DE_ACESSO: Record<string, string> = {
  COM_ACESSO: "Com acesso",
  SEM_ACESSO: "Perdemos o acesso",
  SUSPENSO: "Suspensos pelo Google",
  COPIA: "Marcados como cópia",
  ACESSO_SOLICITADO: "Acesso solicitado",
  NAO_VERIFICADO: "Ainda não verificados",
};

export const CORES_DE_ACESSO: Record<string, string> = {
  COM_ACESSO: GOOGLE.verde,
  SEM_ACESSO: GOOGLE.vermelho,
  SUSPENSO: GOOGLE.amarelo,
  COPIA: "#7B1FA2",
  ACESSO_SOLICITADO: GOOGLE.azul,
  NAO_VERIFICADO: GOOGLE.cinza,
};

export const rotulo = (dicionario: Record<string, string>, chave: string): string =>
  dicionario[chave] ?? chave.replaceAll("_", " ").toLowerCase();

export const total = (fatias: Fatia[]): number => fatias.reduce((soma, fatia) => soma + fatia.value, 0);

export const percentual = (valor: number, base: number): number => (base > 0 ? Math.round((valor / base) * 100) : 0);

/** Os N maiores; o resto vira "Outros" para o gráfico não virar uma escada infinita. */
export const topComOutros = (fatias: Fatia[], quantos: number): Fatia[] => {
  const ordenadas = [...fatias].sort((a, b) => b.value - a.value);
  if (ordenadas.length <= quantos) return ordenadas;
  const topo = ordenadas.slice(0, quantos);
  const resto = ordenadas.slice(quantos).reduce((soma, fatia) => soma + fatia.value, 0);
  return resto > 0 ? [...topo, { label: "Outros", value: resto }] : topo;
};

const MESES = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

export const mesCurto = (yearMonth: string): string => {
  const [ano, mes] = yearMonth.split("-");
  const indice = Number(mes) - 1;
  return indice >= 0 && indice < 12 ? `${MESES[indice]}/${ano.slice(2)}` : yearMonth;
};

/** Completa os 12 meses até o atual com zero, para a linha não pular meses sem cadastro. */
export const ultimosDozeMeses = (fatias: Fatia[], hoje: Date = new Date()): Fatia[] => {
  const porMes = new Map(fatias.map((fatia) => [fatia.label, fatia.value]));
  const saida: Fatia[] = [];
  for (let i = 11; i >= 0; i -= 1) {
    const data = new Date(hoje.getFullYear(), hoje.getMonth() - i, 1);
    const chave = `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, "0")}`;
    saida.push({ label: chave, value: porMes.get(chave) ?? 0 });
  }
  return saida;
};
